<template>
  <div class="workbench-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>招商部</el-breadcrumb-item>
      <el-breadcrumb-item>招商总监工作台</el-breadcrumb-item>
    </el-breadcrumb>

    <el-row :gutter="20" style="margin-top: 20px;">
      <!-- 左侧主要内容区 -->
      <el-col :span="16">
        <!-- 绩效展示区 -->
        <performance class="mb-20" :employee-id="employeeId" :employee-name="employeeName" :target-type="targetType" :url="performanceUrl"></performance>

        <!-- 流量&转化率展示区 -->
        <traffic-conversion class="mb-20" :employee-id="employeeId"  :target-type="targetType" :url="trafficConversionUrl"></traffic-conversion>

        <!-- 部门组员统计 -->
        <member-statistics class="mb-20" :employee-id="employeeId" url="zhaoshang/zongjian/memberStatistics"></member-statistics>

        <!-- 门店省市统计 -->
        <store-province-statistics class="mb-20" :employee-id="employeeId" :url="storeProvinceStatisticsUrl"></store-province-statistics>

        <!-- 客户分店统计 -->
        <customer-store-statistics class="mb-20" :employee-id="employeeId" :url="customerStoreStatisticsUrl"></customer-store-statistics>

      </el-col>

      <!-- 右侧侧边栏 -->
      <el-col :span="8">
        <!-- 流量趋势 -->
        <trend class="mb-20" :employee-id="employeeId" :target-type="targetType" :url="trendUrl"></trend>

        <!-- 来源统计 -->
        <source-statistics class="mb-20" :employee-id="employeeId" :target-type="targetType" :url="sourceStatisticsUrl"></source-statistics>

        <!-- 签约品牌统计 -->
        <brand-statistics class="mb-20" :employee-id="employeeId" :target-type="targetType" :url="brandStatisticsUrl"></brand-statistics>

        <!-- 门店列表展示区 (占位) -->
        <el-card class="box-card mb-20">
          <div slot="header" class="clearfix">
            <span><i class="el-icon-office-building text-blue" style="margin-right: 5px;"></i>门店列表</span>
          </div>
          <div style="text-align: center; color: #909399; padding: 20px;">
            暂未开发，敬请期待
          </div>
        </el-card>

      </el-col>
    </el-row>
  </div>
</template>

<script>
import Performance from './components/Performance'
import TrafficConversion from './components/TrafficConversion'
// import MonthlyRanking from './components/MonthlyRanking'
import Trend from './components/Trend'
import SourceStatistics from './components/SourceStatistics'
import BrandStatistics from './components/BrandStatistics'
import StoreProvinceStatistics from './components/StoreProvinceStatistics'
import CustomerStoreStatistics from './components/CustomerStoreStatistics'
import MemberStatistics from './components/MemberStatistics'

export default {
  name: 'ZhaoshangZhuanyuanWorkbench',
  components: {
    Performance,
    TrafficConversion,
    // MonthlyRanking,
    Trend,
    SourceStatistics,
    BrandStatistics,
    StoreProvinceStatistics,
    CustomerStoreStatistics,
    MemberStatistics
  },
  data () {
    return {
      // 账号信息
      accountInfo: {
        level: null,
        employeeId: '',
        employeeName: '',
        department: '',
        job: ''
      },
      employeeId: '', // 用于传递的员工id
      employeeName: '', // 用于传递的员工姓名

      targetType: 'department',
      performanceUrl: 'zhaoshang/zongjian/performance',
      trafficConversionUrl: 'zhaoshang/zongjian/trafficConversion',
      trendUrl: 'zhaoshang/zongjian/trend',
      sourceStatisticsUrl: 'zhaoshang/zongjian/sourceStatistics',
      brandStatisticsUrl: 'zhaoshang/zongjian/brandStatistics',
      storeProvinceStatisticsUrl: 'zhaoshang/zongjian/storeProvinceStatistics',
      customerStoreStatisticsUrl: 'zhaoshang/zongjian/customerStoreStatistics'
    }
  },
  created () {
    this.getAccountInfo()
  },
  methods: {
    // 获取账号信息
    getAccountInfo () {
      this.accountInfo.level = window.sessionStorage.getItem('level')
      this.accountInfo.employeeId = window.sessionStorage.getItem('employeeId')
      this.accountInfo.employeeName = window.sessionStorage.getItem('employeeName')
      this.accountInfo.department = window.sessionStorage.getItem('department')
      this.accountInfo.job = window.sessionStorage.getItem('job')

      if (this.isAdmin()) {
        this.getEmployeeList()
      } else {
        this.employeeId = this.accountInfo.employeeId
        this.employeeName = this.accountInfo.employeeName
      }
    },

    // 判断是否为管理员或者招商总监
    isAdmin () {
      return this.accountInfo.level <= 1
    },

    // 获取员工列表
    async getEmployeeList () {
      const { data: res } = await this.$http.get('zhaoshang/customer/employees')

      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      const zongjian = res.data.find(item => item.job === '总监')
      if (zongjian) {
        this.employeeId = zongjian._id
        this.employeeName = zongjian.name
      }
    }
  }
}
</script>

<style scoped>
.text-blue { color: #409EFF; }
.mb-20 {
  margin-bottom: 20px;
}
</style>
